
import { inject, Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { OmniSearchAutoCompleteEntry } from "@tylertech/tyler-api-types";

/**
 * OmniSearchService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class OmniSearchService {
    private readonly $apiService = inject(ApiService);
    
    AddRecentSearch(search: string): Promise<void> {
        return this.$apiService.sendAuth("IOmniSearchService/AddRecentSearch", search);
    }
    GetAutoCompleteEntries(searchText: string): Promise<OmniSearchAutoCompleteEntry[]> {
        return this.$apiService.sendAuth("IOmniSearchService/GetAutoCompleteEntries", searchText);
    }
}
